import { ready } from '~/core';
import { addEvents } from '~/utils';



ready('bigChecks', '.bigChecks ', checks => {

    const triggers = [...checks.querySelectorAll('.bigChecks-check')];
    const submitBtn = checks.querySelector('.bigChecks-submit button');

    const prepare = trigger => {

        addEvents(trigger, 'click.self', function(e) {
            e.preventDefault();

            if (trigger.classList.contains('is-active')) {
                trigger.classList.toggle('is-active');
                submitBtn.disabled = true;
                
            }
            else if (document.querySelector('.bigChecks-check.is-active')) {
                document.querySelector('.bigChecks-check.is-active').classList.toggle('is-active');
                trigger.classList.toggle('is-active');
                submitBtn.disabled = false;
            }
            else {
                trigger.classList.toggle('is-active');
                submitBtn.disabled = false;
            }

        });

        const do_next = () => {
            
            window.location.href = document.querySelector('.bigChecks-check.is-active').dataset.href;
            
            
        };
    
        addEvents(submitBtn, 'click.self.prevent', do_next)



        addEvents(trigger, "keyup", (e) => {
            let code = e.which;
            if(code === 32 || code === 13) {
                console.log(e)
            }
        })

	};

    triggers.forEach(trigger => prepare(trigger));


});